import React, { FunctionComponent, lazy, ReactNode } from 'react';
import { Route, Switch } from 'react-router-dom';
import { withRouteProvider } from '@app/lib/router';
import forOwn from 'lodash/forOwn';
import { NotFoundPage } from '../application';

import * as routes from './Routes';

const Routes: FunctionComponent = () => {
  const routeComponents: ReactNode[] = [];
  forOwn(routes, (route, index) =>
    routeComponents.push(route.getRouteComponent({ key: index }))
  );
  return (
    <Switch>
      {routeComponents}
      <Route component={NotFoundPage} />
    </Switch>
  );
};

export default withRouteProvider()(Routes);
